import * as v from 'valibot';
import { weekdaysSchema } from './Weekdays';
export const timeSchema = v.object({
    h: v.number(),
    m: v.number(),
    w: weekdaysSchema,
});
